import {IWordpressBlock} from "./interfaces/IWordpressBlock";

export const textPriceInRubles = (value: string | number) : string => `${value} р.`;

export const getPrivacyPolicyText = (buttonText: string): string => `Нажимая на кнопку “${buttonText}”, вы соглашаетесь с условиями предоставления услуг и `;

// export const isGeneration = process.env.LAUNCH_MODE === 'GENERATION';
export const isGeneration = false;

export const getScreenWidth = () => {
  if (isGeneration) {
    return 720;
  }
  return window.screen.width;
}

export const getDeliveryBlockBgByColor = (color?: string) => {
  return (
    <svg width="740" height="740" viewBox="0 0 740 740" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g opacity="0.5" filter="url(#filter0_f_4195_5281)">
        <path
          d="M511.434 511.434C459.359 563.508 353.823 542.401 275.711 464.289C197.599 386.177 176.492 280.641 228.566 228.566C280.641 176.492 386.177 197.599 464.289 275.711C542.401 353.823 563.508 459.359 511.434 511.434Z"
          fill={color ? color : 'none'}
        />
      </g>
      <defs>
        <filter
          id="filter0_f_4195_5281"
          x="0"
          y="0"
          width="740"
          height="740"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"/>
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
          <feGaussianBlur stdDeviation="100" result="effect1_foregroundBlur_4195_5281"/>
        </filter>
      </defs>
    </svg>
  );;
}

export const defaultValueForImage = '<do-not-edit-this>';

export const loadContent = (globalVariableName: any = 'dalliContent') => {
  if (isGeneration) {
    // return require('../../../content.json').default;
    return {};
  }

  if (globalVariableName in window) {
    return window[globalVariableName] as {[key: string]: any};
  } else {
    console.warn(`not defined variable ${globalVariableName} in global scope`);
  }

  return {};
}

export const loadPageContent = (pagepath: string) => {
  // page = page.replace(/\//g, '');
  const content = loadContent('dalliPagesContent') as {[key: string]: any};
  if (pagepath in content) {
    return content[pagepath];
  }
  return {};
}

export const getPageName = (pathname: string) : string => {
  if (pathname === '/') {
    return 'main';
  }
  return pathname;
}


const isObject = (value: any): boolean => typeof value === 'object' && !Array.isArray(value) && value !== null;

export const isEmpty = (object: object) => Object.keys(object).length === 0;

export const emptyBlock = (<></>);

export const mergeContent = (defaultContent: {[key: string]: any}, userContent: {[key: string]: any}) => {
  const result: {[key: string]: any} = {};
  Object.keys(defaultContent).forEach(key => {
    const value: any = defaultContent[key];
    if (!(key in userContent)) {
      result[key] = value;
      return;
    }
    let type;
    if (isObject(value)) {
      type = 'object';
      result[key] = mergeContent(defaultContent[key], userContent[key]);
    } else {
      type = 'primitive';
      result[key] = userContent[key];
    }
    // console.log(key, type, type === 'primitive' ? result[key] : '');
  });
  return result;
}

export const prepareOrder = (data: { [key: string]: IWordpressBlock }) => {
  return Object.keys(data).sort((k1, k2) => data[k1]?.order - data[k2]?.order);
}
